module.exports = __webpack_public_path__ + "static/media/main_100.e9b5d6de.ico";